import { render, staticRenderFns } from "./SettingsNotifications.vue?vue&type=template&id=395a4549&"
import script from "./SettingsNotifications.vue?vue&type=script&lang=js&"
export * from "./SettingsNotifications.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports